export default "/dist/files/icone_climat.95bbe950c3bf21da11575b05792c617d.svg";